import { Alert, Box } from "@mui/material";

import StatusQueue from "../../../Assets/Icons/status-queue.png";
import StatusHold from "../../../Assets/Icons/status-hold.png";
import StatusInProgress from "../../../Assets/Icons/status-in-progress.png";
import StatusComplete from "../../../Assets/Icons/status-complete.png";
import StatusCanceled from "../../../Assets/Icons/status-canceled.png";

const StatusAlert = ({ formDetails }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case "Completed":
        return StatusComplete;
      case "On Hold":
        return StatusHold;
      case "In Progress":
        return StatusInProgress;
      case "In Queue":
        return StatusQueue;
      case "Canceled":
        return StatusCanceled;
      default:
        return "";
    }
  };

  const statusColors = {
    "On Hold": {
      background: "#fff3e0",
      color: "#e65100",
      border: "#ffe0b2",
    },
    "In Progress": {
      background: "#e3f2fd",
      color: "#2196f3",
      border: "#bbdefb",
    },
    Completed: {
      background: "#e8f5e9",
      color: "#4caf50",
      border: "#c8e6c9",
    },
    "In Queue": {
      background: "#f5f5f5",
      color: "#757575",
      border: "#e0e0e0",
    },
    Canceled: {
      background: "#ffebee",
      color: "#d32f2f",
      border: "#ffcdd2",
    },
  };

  return (
    <>
      {formDetails?.order_current_status_message && (
        <Alert
          severity="info"
          icon={false}
          sx={{
            mb: 2,
            backgroundColor:
              statusColors[formDetails?.status]?.background || "#f5f5f5",
            color: statusColors[formDetails?.status]?.color || "#757575",
            border: "1px solid",
            borderColor: statusColors[formDetails?.status]?.border || "#e0e0e0",
            borderRadius: "8px", // Slightly more rounded
            fontSize: "0.875rem",
            fontWeight: 500,
            fontFamily: "Lexend, sans-serif",
            // Add subtle shadow for depth
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
            // Add left border accent
            borderLeft: "4px solid",
            borderLeftColor:
              statusColors[formDetails?.status]?.color || "#757575",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <img
              src={getStatusIcon(formDetails?.status)}
              alt="status icon"
              width={24}
              height={24}
              style={{
                filter:
                  formDetails?.status === "In Queue" ? "invert(50%)" : "none",
              }}
            />
            {formDetails?.order_current_status_message}
          </Box>
        </Alert>
      )}
    </>
  );
};

export default StatusAlert;
